export default __webpack_public_path__ + "static/media/random.ba9cba21.png";